module.exports = __webpack_public_path__ + "img/seafood.768a9010.png";